export enum ContactType {
  User = 'user',
  Lead = 'lead',
  Visitor = 'visitor',
}
